module.exports = __webpack_public_path__ + "img/tick-selected.94e7c53c.svg";